import {
	createFileUploadSlice,
	initialFileState,
} from 'library/redux/fileUpload';
import { IFileUploadStateHandlers } from 'modules/Shared/Components/FileUpload/UploadFileSection';

import { selectHealthCheckFiles } from './Selectors';
import { resetState } from './Thunk';

const generateHealthCheckFilesSlice = createFileUploadSlice({
	name: 'generateHealthCheckFiles',
	initialState: initialFileState,
	reducers: {},
	extraReducers(builder) {
		builder.addCase(resetState.fulfilled, () => initialFileState);
	},
});

export const { fileUploaded, fileDeleted, attachmentFolderCreated } =
	generateHealthCheckFilesSlice.actions;

export const healthCheckFilesHandler: IFileUploadStateHandlers = {
	attachmentFolderCreated,
	fileDeleted,
	fileUploaded,
	fileStateSelector: selectHealthCheckFiles,
};

export default generateHealthCheckFilesSlice.reducer;
